<template lang="pug">
include /mixins
+b.ticket-form-wrapper
  //- +e.title-wrap(v-if='appealType')
  //-   +e.title.H1 {{ appealType.props.title }}
  //-   +e.description.P {{ appealType.props.description }}
  +e.circle--large.IMG(src='/static/img/redesign/ticket_circle_2.svg')

  +e.form
    ticket-form(
      :ticket='ticket'
      :url='url'
      :ticket_hash='ticket_hash'
    )
    +e.circle--mini.IMG(src='/static/img/redesign/ticket_circle_1.svg')
</template>

<script>

import TicketForm from '@app/TicketManagement/Form'

export default {
  name: 'TicketAdd',
  components: {
    TicketForm,
  },
  props: {
    ticket: {},
    url: {},
    ticket_hash: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
    }
  },
  computed: {
  },
  mounted() {

  },
  methods: {
  },
}
</script>
